<template>
  <div class="tw:w-full" data-testid="rc-plus-cross-sell-subscription-success">
    <div
      class="tw:mb-3 tw:bg-green-700 tw:h-[40px] tw:w-[40px] tw:rounded-full tw:flex tw:items-center tw:justify-center">
      <div class="tw:bg-white tw:h-[20px] tw:w-[20px] tw:rounded-full tw:flex tw:items-center tw:justify-center">
        <CheckmarkSimple class="tw:stroke-green-700 tw:fill-none tw:size-6" />
      </div>
    </div>
    <p class="tw:font-bold">{{ $t('subscription_activated_header') }}</p>
    <p class="tw:text-sm">{{ $t('subscription_activated_subtext') }}</p>
    <p class="tw:mt-6 tw:text-sm">{{ $t('plus_features_info') }}</p>
    <div
      class="tw:hidden tw:md:flex tw:mt-4 tw:px-4 tw:h-[44px] tw:rounded-lg tw:text-xs tw:items-center tw:justify-between tw:gap-x-5 tw:shadow-[2px_2px_15px_0px_rgba(23,23,23,0.15)]"
      aria-hidden="true">
      <div>{{ $t('navigation.home') }}</div>
      <div>{{ $t('app.rateConnect.name') }}</div>
      <div class="nav-item-highlight tw:relative tw:font-bold tw:text-blue-700">
        {{ $t('navigation_menu_business_studio_plus') }}
      </div>
      <div>{{ $t('hotel_offers_product_header') }}</div>
      <div>{{ $t('app.rateInsights.name') }}</div>
      <div>{{ $t('app.visitorsProfile.name') }}</div>
    </div>
    <div
      class="tw:md:hidden tw:mt-4 tw:p-4 tw:text-sm tw:border tw:rounded-xl tw:border-gray-300 tw:flex tw:flex-col tw:gap-y-6 tw:relative tw:overflow-visible"
      aria-hidden="true">
      <div>{{ $t('navigation.home') }}</div>
      <div>{{ $t('app.rateConnect.name') }}</div>
      <div class="nav-item-highlight-mobile tw:relative tw:flex tw:items-center tw:justify-between">
        <div class="tw:font-bold tw:text-blue-700">{{ $t('navigation_menu_business_studio_plus') }}</div>
        <span
          class="tw:px-2 tw:py-[5px] tw:leading-[12px] tw:text-xs tw:text-white tw:font-bold tw:bg-red-700 tw:rounded-tl-2xl tw:rounded-br-2xl">
          {{ $t('business_studio_plus_new_flag') }}
        </span>
      </div>
      <div>{{ $t('app.propertyDetails.name') }}</div>
    </div>
  </div>
</template>

<script setup>
import CheckmarkSimple from '@/components/icons/CheckmarkSimple.svg?component'
</script>

<style scoped>
.nav-item-highlight::before {
  content: '';
  position: absolute;
  top: -14px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 7px solid var(--tw-color-blue-700);
}

.nav-item-highlight-mobile::before {
  content: '';
  position: absolute;
  top: 50%;
  left: -13px;
  transform: translate(-50%, -50%);
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 7px solid var(--tw-color-blue-700);
}
</style>
